import { createFileRoute, notFound } from '@tanstack/react-router';

// A URL no other route matches. It sits under `_authenticated` so that, like any page, it first
// signs the user in and loads their preferences, which the navigation menu reads.
export const Route = createFileRoute('/_authenticated/$')({
    beforeLoad: () => {
        throw notFound();
    },
});
